import React, { useEffect, useState, useCallback, useMemo, useContext } from 'react'
import { Text } from 'rebass'
import styled, {ThemeContext} from 'styled-components'
import { NavLink } from 'react-router-dom'
import { provider } from 'web3-core'

// components
// import { BodyHead, BodyTitle } from '../../components/bakery/styleds'
import PlateCard from '../../components/restaurant/PlateCard'
import { Input as NumericalInput } from '../../components/NumericalInput'
import { ButtonLight, ButtonPrimary, ButtonConfirmed } from '../../components/Button'
import Value from '../../components/Value/OnlyValue'
import DishesPreviewModal from '../../components/restaurant/DishesPreviewModal'
import Loader from '../../components/Loader'
import { AutoRow } from '../../components/Row'

// hooks
import { useActiveWeb3React } from '../../hooks'
import { useWalletModalToggle } from '../../state/application/hooks'
import useYam from '../../hooks/bakery/useYam'
import useTokenBalance from '../../hooks/bakery/useTokenBalance'
import useAllowanceDish from '../../hooks/nft/useAllowanceDish'
import useApproveDish from '../../hooks/nft/useApproveDish'
import useSynthesis from '../../hooks/nft/useSynthesis'
import useAllDishes from '../../hooks/nft/useAllDishes'
import useBlock from '../../hooks/bakery/useBlock'
import useRoi from '../../hooks/nft/useRoi'

// utils
import { BigNumber } from '../../sushi'
import { getSushiAddress } from '../../sushi/utils'
import { getBalanceNumber } from '../../utils/bakery/formatBalance'
import { getContract } from '../../utils/bakery/erc20'
import { BIGNUMBER_FMT } from '../../constants/bakery'

const CardItem = styled.div`
  width: 202px;

  ${({ theme }) => theme.mediaWidth.upToLarge`
    margin-bottom: 64px;
  `}

  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 250px;
    margin-bottom: 64px;
  `}
`
const CardWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 886px;
  margin-top: 26px;

  ${({ theme }) => theme.mediaWidth.upToLarge`
    width: 800px;
    justify-content: space-between;
    padding: 0px 20px;
  `}

  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 600px;
    justify-content: space-between;
    padding: 0px 20px;
  `}

  ${({ theme }) => theme.mediaWidth.upToSmall`
    flex-direction: column;
    width: initial;
  `}
`
const CardTitle = styled.div`
  padding: 9px 0 0 24px;
`
const RangeWrapper = styled.div`
  display: flex;
  align-items: center;
  color: #fff3e0;
  padding-bottom: 12px;
`
const BasicList = () => {
  const showList = [
    {
      iconUrl: (process.env.REACT_APP_DISH_URL ?? '') + '/api/set0001/000000.svg',
      name: 'Basic',
      range: '10K-20K',
      items: 3,
      level: 1
    },
    {
      iconUrl: (process.env.REACT_APP_DISH_URL ?? '') + '/api/set0001/01010101.svg',
      name: 'Regular',
      range: '20K-50K',
      items: 4,
      level: 2
    },
    {
      iconUrl: (process.env.REACT_APP_DISH_URL ?? '') + '/api/set0001/1010101010.svg',
      name: 'Luxury',
      range: '50K-100K',
      items: 5,
      level: 3
    },
    {
      iconUrl: (process.env.REACT_APP_DISH_URL ?? '') + '/api/set0001/111111111111.svg',
      name: 'Supreme',
      range: '100K+',
      items: 6,
      level: 4
    }
  ]
  const Row = showList.map((d, i) => {
    return (
      <CardItem key={i}>
        <PlateCard iconUrl={d.iconUrl} items={d.items} level={d.level} smallLevelIcon={true}>
          <CardTitle>
            <Text fontSize={22}>{d.name}</Text>
            <RangeWrapper>
              <Text fontSize={14}>{d.range}</Text>
              <img src="/images/bakery/icon_doughnut.svg" alt="bake_logo" width={18} style={{ marginLeft: 8 }} />
            </RangeWrapper>
          </CardTitle>
        </PlateCard>
      </CardItem>
    )
  })
  return <CardWrapper>{Row}</CardWrapper>
}

const FormWrapper = styled.div`
  background: ${({ theme }) => theme.bsBg6};
  box-shadow: 0px 2px 10px ${({ theme }) => (theme.darkMode ? 'transparent' : 'rgba(171, 133, 115, 0.16)')};
  border-radius: 20px;
  width: 432px;
  height: 356px;
  padding: 16px 68px 20px;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    padding: 16px 28px 20px;
    width: 90%;
    margin: auto;
  `};
`
const RowInput = styled.div`
  display: flex;
  align-items: center;
  background: ${({ theme }) => theme.bsBg5};
  border: 1px solid ${({ theme }) => theme.bsBorder1};
  border-radius: 10px;
  height: 48px;
  padding: 0 16px;
`
const StyledBalanceMax = styled.button`
  height: 28px;
  background-color: ${({ theme }) => theme.primary5};
  border: 1px solid ${({ theme }) => theme.primary5};
  border-radius: 0.5rem;
  font-size: 0.875rem;
  font-family: Baloo Da;
  font-weight: 500;
  cursor: pointer;
  margin-right: 0.2rem;
  color: ${({ theme }) => theme.primaryText1};
  :hover {
    border: 1px solid ${({ theme }) => theme.primary1};
  }
  :focus {
    border: 1px solid ${({ theme }) => theme.primary1};
    outline: none;
  }

  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    margin-right: 0.2rem;
  `};
`
const BakeText = styled.div`
  color: #d6a485;
`
const AttachWrapper = styled.div`
  margin: 0.5rem 0 1rem;
`
const AttachRow = styled.div<{ marginBottom?: number }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${({ theme }) => theme.bsText3};
  margin-bottom: ${({ marginBottom }) => (marginBottom ? marginBottom : 0)}px;
`
const MyDishes = styled(NavLink)`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.bsText7};
  border-radius: 10px;
  color: ${({ theme }) => theme.primary1};
  font-family: Baloo Da;
  height: 40px;
  text-decoration: none;
  margin-top: 10px;
`
const ValueItem = styled.div`
  display: flex;
  align-items: center;
  max-width: 150px;
`
const Box = styled.div`
  display: flex;
  align-items: center;
  margin-top: 40px;
  flex-wrap: wrap;
`
const Info = styled.div`
  color: ${({ theme }) => theme.bsText7};
  width: 432px;
  height: 356px;
  overflow-y: scroll;
  padding: 16px 30px;
  border-radius: 20px;
  margin-right: 26px;
  background: ${({ theme }) => theme.bsBg2};
  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 90%;
    height: auto;
    margin: 0 auto;
    margin-bottom: 20px;
  `};
`

const MINBAKE = 10000
interface DishInfos {
  level: number
  stakingPowerMultiple: number
  bakeAmount: BigNumber
  stakingPowerAmount: BigNumber
  items: string[]
  tokenId: string
  dishIcon: string
}
export default function Restaurant() {
  const { account, library } = useActiveWeb3React()
  const ethereum = library?.provider
  const theme = useContext(ThemeContext)
  const comboBtn = true  // 禁用combo前端按钮

  // connect wallet
  const [modalOpen, setModalOpen] = useState(false)
  const toggleWalletModal = useWalletModalToggle()
  const handleDismissSearch = useCallback(() => {
    setModalOpen(false)
  }, [setModalOpen])

  // bake balance
  const [bakeBalance, setBakeBalance] = useState(0)
  const yam = useYam()
  const bakeryBalance = useTokenBalance(getSushiAddress(yam))
  useEffect(() => {
    const balance = getBalanceNumber(bakeryBalance)
    setBakeBalance(balance)
  }, [yam, bakeryBalance])

  // approve bake
  const [requestedApproval, setRequestedApproval] = useState(false)
  const lpTokenAddress = getSushiAddress(yam)
  const lpContract = useMemo(() => {
    return getContract(ethereum as provider, lpTokenAddress)
  }, [ethereum, lpTokenAddress])
  const allowanceDish = useAllowanceDish(lpContract)
  const { onApprove } = useApproveDish(lpContract)
  const handleApprove = useCallback(async () => {
    try {
      setRequestedApproval(true)
      const txHash = await onApprove()
      // user rejected tx or didn't go thru
      if (!txHash) {
        setRequestedApproval(false)
      }
    } catch (e) {
      console.log(e)
    }
  }, [onApprove, setRequestedApproval])

  // input
  const [bakeAmount, setBakeAmount] = useState('')
  const onUserInput = (val: string) => {
    setBakeAmount(val)
  }

  // decompose tips
  const [decomposeAmount, setDecomposeAmount] = useState(new BigNumber(0))
  // power
  const [power, setPower] = useState('0')
  const [stakingPowerMultiple, setStakingPowerMultiple] = useState(0)
  useEffect(() => {
    const val = bakeAmount ? bakeAmount : 0
    setDecomposeAmount(new BigNumber(val).multipliedBy(0.9))

    const amount = new BigNumber(bakeAmount)
    const amount1 = new BigNumber(MINBAKE)
    const amount2 = new BigNumber(MINBAKE).multipliedBy(2)
    const amount5 = new BigNumber(MINBAKE).multipliedBy(5)
    const amount10 = new BigNumber(MINBAKE).multipliedBy(10)
    switch (true) {
      case amount.gte(amount1) && amount.lt(amount2):
        setStakingPowerMultiple(200000)
        break
      case amount.gte(amount2) && amount.lt(amount5):
        setStakingPowerMultiple(260000)
        break
      case amount.gte(amount5) && amount.lt(amount10):
        setStakingPowerMultiple(300000)
        break
      case amount.gte(amount10):
        setStakingPowerMultiple(330000)
        break
      default:
        setStakingPowerMultiple(0)
    }
    setPower(
      amount.gt(0)
        ? amount
            .multipliedBy(stakingPowerMultiple)
            .div(100000)
            .toFormat(BIGNUMBER_FMT)
        : '0'
    )
  }, [bakeAmount, stakingPowerMultiple])

  const currentBlock = useBlock()
  const roi = useRoi(currentBlock, stakingPowerMultiple)
  const minRoi = useRoi(currentBlock, 100000)
  const maxRoi = useRoi(currentBlock, 500000)

  // Allowance make dish
  const [allowanceMakeDish, setAllowanceMakeDish] = useState<boolean>(false)
  useEffect(() => {
    const isAllowance = new BigNumber(bakeAmount).gte(MINBAKE) && new BigNumber(bakeAmount).lte(bakeBalance)
    setAllowanceMakeDish(isAllowance)
  }, [bakeBalance, bakeAmount])

  // Make dish
  const [synthesisDish, setSynthesisDish] = useState<DishInfos | null>(null)
  const getUnstakingDishes = useAllDishes(true)
  const [pendingTx, setPendingTx] = useState(false)
  const { onSynthesis } = useSynthesis()
  const makeMyDish = useCallback(async () => {
    try {
      setPendingTx(true)
      const txHash = await onSynthesis(bakeAmount)
      // synthesis dish success
      if (txHash) {
        console.log('txHash', txHash)
        const list = await getUnstakingDishes()
        const handledList = list?.map(data => {
          return {
            ...data,
            dishIcon:
              data.items
                .map((d: string | number) => {
                  const valBinary = new BigNumber(d)
                    .div(100000)
                    .integerValue(BigNumber.ROUND_FLOOR)
                    .toString(2)
                  return valBinary.length < 2 ? '0' + valBinary : valBinary
                })
                .join('') + '.svg'
          }
        })
        if (handledList && handledList.length > 0) {
          setSynthesisDish(handledList[0])
          console.log('handledList[0]', handledList[0])
        }
        setModalOpen(true)
      }
    } catch (e) {
      console.log(e)
    }
    setPendingTx(false)
  }, [bakeAmount, onSynthesis, getUnstakingDishes])

  // min&max button
  const [showMinButton, setShowMinButton] = useState(true)
  const [showMaxButton, setShowMaxButton] = useState(true)
  const onMin = useCallback(() => {
    setBakeAmount('10000')
    setShowMinButton(false)
    if (new BigNumber(bakeBalance).gt(0)) setShowMaxButton(true)
  }, [bakeBalance])
  const onMax = useCallback(() => {
    setBakeAmount(new BigNumber(bakeBalance).toFixed(3, BigNumber.ROUND_FLOOR))
    setShowMaxButton(false)
    setShowMinButton(true)
  }, [bakeBalance])
  useEffect(() => {
    if (bakeAmount === '') {
      setShowMinButton(true)
      if (new BigNumber(bakeBalance).gt(0)) setShowMaxButton(true)
    }
  }, [bakeAmount, bakeBalance])

  return (
    <>
      {/* <BodyHead>
        <BodyTitle fontSize={32} fontWeight={700}>
          Bakery Combo
        </BodyTitle>
        <Text fontSize={14} fontWeight={500}>
          Wish you best of luck in making Combos{' '}
          <span role="img" aria-label="smile">
            😋
          </span>
        </Text>
      </BodyHead> */}
      <BasicList></BasicList>
      <Box>
        <Info>
          <Text fontSize={18} fontFamily={'Baloo Da'} fontWeight={700}>What are NFT Combo Meals?</Text>
          <Text fontSize={14} marginTop={20}>NFT Combo Meals increase your staking power and earnings when farmimg on BakerySwap!</Text>
          <Text fontSize={14} marginTop={20}>We have 4 tiers of combos, Basic, Regular, Luxury, and Supreme. To compose a combo, you need to contribute BAKE, and the more BAKE you contribute, the higher tier combo you will have, which generates the higher staking power. </Text>
          <Text fontSize={14} marginTop={20}>However, there is a random factor when generating staking power like a raffle game, so you will have the chance to get a combo with higher staking power at a low cost like a jackpot, anyway, the lowest is still much higher than normal BAKE staking. </Text>
          <Text fontSize={14} marginTop={20}>Then you can stake your combo to earn BAKE based on the staking power of it. Other than staking, you can also list your combo under the Bakery Combo tab of the NFT Marketplace and sell it to others to make a profit.</Text>
          <Text fontSize={14} marginTop={20}>To protect the interests of combo participants, we have a “decompose” function so that an NFT combo can be decomposed back to BAKE. With this feature, you don’t need to go through a long staking process to cover what you paid for your combo, or sell it at a discount when no one takes over the combo on the market, you only need to decompose the NFT Combo and get back 90% of the BAKE you participated.</Text>
          <Text fontSize={14} marginTop={20}>Our Combo Meals are open for a limited time now, from Feb 20 6:00 AM to March 12 6:00 AM UTC, hurry up for your delicious NFT Combo Meals!</Text>
        </Info>
        <FormWrapper>
          <AttachRow style={{ marginBottom: 8 }}>
            <Text fontSize={12} fontWeight={700}>Balance:</Text>
            <Text fontSize={14} color={theme.bsText7} fontWeight={700} fontFamily={'Baloo Da'} style={{ marginLeft: 8 }}>
              <ValueItem>
                <Value decimals={3} value={new BigNumber(bakeBalance).toFixed(3, BigNumber.ROUND_FLOOR)} /> &nbsp;BAKE
              </ValueItem>
            </Text>
          </AttachRow>
          <RowInput>
            <NumericalInput
              className="token-amount-input"
              value={bakeAmount}
              style={{ marginRight: 5 }}
              onUserInput={val => {
                onUserInput(val)
              }}
            />
            {
              account && (
                <>
                  {showMinButton && <StyledBalanceMax onClick={onMin}>Min</StyledBalanceMax>}
                  {showMaxButton && new BigNumber(bakeBalance).gt(0) && <StyledBalanceMax onClick={onMax}>MAX</StyledBalanceMax>}
                </>
              )
            }
            <BakeText>
              <Text fontWeight={700}>BAKE</Text>
            </BakeText>
          </RowInput>
          <AttachWrapper>
            <AttachRow marginBottom={5}>
              <Text fontSize={12} fontWeight={700}>Decompose to get:</Text>
              <Text fontSize={14} color={theme.bsText7} fontWeight={700} fontFamily={'Baloo Da'} style={{ marginLeft: 8 }}>
                <ValueItem>
                  <Value decimals={0} value={decomposeAmount.toNumber()} /> &nbsp;BAKE
                </ValueItem>
              </Text>
            </AttachRow>
            <AttachRow marginBottom={5} >
              <Text fontSize={12} fontWeight={700}>Staking Power:</Text>
              <Text fontSize={14} color={theme.bsText7} fontWeight={700} fontFamily={'Baloo Da'} marginLeft="8px">
                {new BigNumber(bakeAmount).gt(0)
                  ? new BigNumber(bakeAmount).toFormat(BIGNUMBER_FMT) +
                    '~' +
                    new BigNumber(bakeAmount).multipliedBy(5).toFormat(BIGNUMBER_FMT)
                  : '0'}
              </Text>
            </AttachRow>
            <AttachRow marginBottom={5}>
              <Text fontSize={12} fontWeight={700}>Average:</Text>
              <Text fontSize={14} color={theme.bsText7} fontWeight={700} fontFamily={'Baloo Da'} marginLeft="8px">
                {power}
              </Text>
            </AttachRow>
            <AttachRow marginBottom={5}>
              <Text fontSize={12} fontWeight={700}>ROI:</Text>
              <Text fontSize={12} color={theme.bsText7} fontWeight={700} fontFamily={'Baloo Da'} marginLeft="8px">
                {minRoi && maxRoi
                  ? `${minRoi.times(new BigNumber(100)).toFormat(2, BIGNUMBER_FMT)}% ~ ${maxRoi
                      .times(new BigNumber(100))
                      .toFormat(2, BIGNUMBER_FMT)}%`
                  : '-'}
              </Text>
            </AttachRow>
            <AttachRow marginBottom={5}>
              <Text fontSize={12} fontWeight={700}>Average:</Text>
              <Text fontSize={14} color={theme.bsText7} fontWeight={700} fontFamily={'Baloo Da'} marginLeft="8px">
                {roi && !roi.isNaN() && roi.gt(0) ? roi.times(new BigNumber(100)).toFormat(2, BIGNUMBER_FMT) + '%' : '-'}
              </Text>
            </AttachRow>
          </AttachWrapper>
          {!account ? (
            <ButtonLight height={40} onClick={toggleWalletModal}>
              Connect Wallet
            </ButtonLight>
          ) : comboBtn ? 
          <ButtonPrimary 
            disabled={true} 
            altDisabledStyle={true}
            height={40}
            padding="0px 18px">
            Combo Making Ended
          </ButtonPrimary> : false ? (
            <ButtonPrimary
              disabled={true}
              altDisabledStyle={true}
              height={40}
              padding="0px 18px"
            >All Combos are sold out</ButtonPrimary>
          ) : allowanceDish.toNumber() ? (
            <ButtonPrimary
              disabled={!allowanceMakeDish || pendingTx}
              altDisabledStyle={!allowanceMakeDish}
              height={40}
              padding="0px 18px"
              onClick={makeMyDish}
            >
              {!bakeAmount || allowanceMakeDish ? (
                pendingTx ? (
                  <AutoRow gap="6px" justify="center">
                    Making <Loader stroke="white" />
                  </AutoRow>
                ) : new BigNumber(bakeAmount).gte(MINBAKE) ? (
                  'Make my Combo'
                ) : (
                  'Minimum 10000 BAKE'
                )
              ) : new BigNumber(bakeAmount).lt(MINBAKE) ? (
                'Minimum 10000 BAKE'
              ) : (
                'Insufficient BAKE balance'
              )}
            </ButtonPrimary>
          ) : (
            <ButtonConfirmed
              onClick={handleApprove}
              disabled={requestedApproval || !allowanceMakeDish}
              width="100%"
              height={40}
              padding="0px 18px"
            >
              {requestedApproval ? (
                <AutoRow gap="6px" justify="center">
                  Approving <Loader stroke="white" />
                </AutoRow>
              ) : allowanceMakeDish ? (
                'Approve BAKE'
              ) : new BigNumber(bakeAmount).lt(MINBAKE) || new BigNumber(bakeAmount).isNaN() ? (
                'Minimum 10000 BAKE'
              ) : (
                'Insufficient BAKE balance'
              )}
            </ButtonConfirmed>
          )}
          {!!account && <MyDishes to={'/myArtwork/combo'}>My Combos</MyDishes>}
        </FormWrapper>
      </Box>
      
      <DishesPreviewModal isOpen={modalOpen} onDismiss={handleDismissSearch} dish={synthesisDish} />
    </>
  )
}
